import { Toast } from '@base-ui/react';

// Re-export Base UI's useToastManager with our name
export function useSDSToast() {
  return Toast.useToastManager();
}
